import { Link } from 'react-router-dom';
import { topics as topicsPool } from '@/mocks/topics';
import { formatHeat } from '@/utils/format';

interface RelatedTopicsProps {
  currentId: string;
  currentCategory: string;
}

export default function RelatedTopics({ currentId, currentCategory }: RelatedTopicsProps) {
  const related = [...topicsPool]
    .filter((t) => t.id !== currentId)
    .sort((a, b) => {
      const aScore = a.category === currentCategory ? 1 : 0;
      const bScore = b.category === currentCategory ? 1 : 0;
      return bScore - aScore || b.heat - a.heat;
    })
    .slice(0, 4);

  return (
    <ul className="space-y-3">
      {related.map((t) => (
        <li key={t.id}>
          <Link
            to={`/topics/${t.id}`}
            className="group block cursor-pointer rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
          >
            <h3 className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 group-hover:text-primary-600">
              {t.title}
            </h3>
            <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
              <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">{t.category}</span>
              <span className="flex items-center gap-1">
                <i className="ri-fire-line text-primary-500" />
                {formatHeat(t.heat)}
              </span>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  );
}